function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M33.4322 9.5C34.2651 9.5 34.947 10.1764 34.8753 11.0062C34.7214 12.7882 34.2949 14.539 33.6081 16.197C32.7287 18.3202 31.4396 20.2493 29.8146 21.8744C28.1896 23.4994 26.2604 24.7884 24.1372 25.6679C22.014 26.5473 19.7384 27 17.4402 27C15.1421 27 12.8665 26.5473 10.7433 25.6679C8.62008 24.7884 6.6909 23.4994 5.06587 21.8744C3.44085 20.2493 2.15181 18.3202 1.27235 16.197C0.585616 14.539 0.159125 12.7882 0.00518108 11.0062C-0.066506 10.1764 0.615432 9.5 1.44832 9.5C2.28121 9.5 2.94828 10.177 3.03485 11.0054C3.17963 12.3909 3.52382 13.7509 4.05892 15.0427C4.7868 16.8 5.85367 18.3967 7.19862 19.7416C8.54357 21.0866 10.1403 22.1534 11.8975 22.8813C13.6548 23.6092 15.5382 23.9838 17.4402 23.9838C19.3423 23.9838 21.2257 23.6092 22.983 22.8813C24.7402 22.1534 26.3369 21.0866 27.6819 19.7416C29.0268 18.3967 30.0937 16.8 30.8216 15.0427C31.3567 13.7509 31.7008 12.3909 31.8456 11.0054C31.9322 10.177 32.5993 9.5 33.4322 9.5Z",
  fill: "#F2C94C"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_i)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.977 6.85903C25.7661 6.58253 26.1919 5.71063 25.7937 4.97542C25.108 3.70961 24.1403 2.61007 22.9577 1.76634C21.3621 0.628018 19.4535 0.0110729 17.4935 8.82374e-05C15.5336 -0.0108964 13.6182 0.584617 12.0099 1.70499C10.8179 2.5354 9.83791 3.62402 9.13814 4.88207C8.7317 5.61277 9.14767 6.48939 9.93361 6.77472C10.7195 7.06005 11.5746 6.63974 12.0343 5.94135C12.4841 5.25804 13.062 4.6623 13.7407 4.18944C14.8364 3.42617 16.1413 3.02046 17.4766 3.02794C18.8118 3.03543 20.1121 3.45574 21.1991 4.23125C21.8725 4.71168 22.4437 5.31386 22.8858 6.00217C23.3377 6.70567 24.1879 7.13553 24.977 6.85903Z",
  fill: "black"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_i",
  x: 8.97986,
  y: -0.0000610352,
  width: 16.9654,
  height: 8.94385,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow"
})));

var SvgLogo0 = function SvgLogo0(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 27,
    viewBox: "0 0 35 27",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo0, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo0.bee2735c.svg";
export { ForwardRef as ReactComponent };